
import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { withRouter } from 'react-router-dom';
function ScrollToTop({ history }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    }
  }, []);

  return (null);
}

const ToTop = withRouter(ScrollToTop);
// import Preloader from "./Preloader";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Transition, TransitionGroup } from "react-transition-group";
import { play, exit } from "./timelines";
import Nav from "./Nav";
import Home from "./views/Home";

import Safety from "./views/Safety";
import Description from "./views/Description";
import ProofOfConcept from "./views/ProofOfConcept";
import Implementation from "./views/Implementation";

import Modeling from "./views/Modeling";
import Hardware from "./views/Hardware";
import Contribution from "./views/Contribution"
import Collaborations from "./views/Collaborations";


import Education from "./views/Education";
import HumanPractices from "./views/HumanPractices";

import Parts from "./views/Parts";


import Elona from "./views/Elona";
import Mst from "./views/Mst";
import Lfa from "./views/Lfa";
import LabJournal from "./views/LabJournal";
import LabGoals from "./views/LabGoals";
import Engineering from "./views/Engineering";

import Attribution from "./views/Attribution";
import Inclusivity from "./views/Inclusivity";

import Footer from './Footer';
import Team from './views/Team';

import Entrepreneurship from './views/Entrepreneurship';
import Awards from './views/Awards';
gsap.registerPlugin(ScrollTrigger);

const App = () => {
  const progressbarRef = useRef();
  
  useEffect(() => {
    document.getElementById("buttondown").onclick = function () {
      window.scrollTo({
        top: 1000,
        behavior: "smooth"
      });
    }
    gsap.to(".buttondown", {
      opacity: 1,
      ease: "none",
      scrollTrigger: {
        trigger: '.app',
        scrub: 1,
        start: 0,
        end: 100,
        // markers: true
      }
    });

    gsap.to("progress", {
      value: 100,
      ease: "none",
      scrollTrigger: {
        trigger: '.app',
        scrub: 0,
        start: "top",
        
        end: "bottom 100%",
        // markers: true
      }
    });
    
  });
  return (
    <BrowserRouter basename='/cityu-hongkong/'>
      <div className="app">
        <a className="buttondown" id="buttondown" href="#">UP <img src="https://static.igem.wiki/teams/4154/wiki/assets/up-arrow.svg" alt="" /></a>
        <progress
          id="proogressbar"
          ref={progressbarRef}
          max="100"
          value="0"
        ></progress>

        <div className="progress" role="progressbar" >
        </div>

        
        <Route
          render={({ location }) => {
            const { pathname, key } = location;

            return (
              <TransitionGroup component={null}>
                <Transition
                  key={key}
                  // appear={true}
                  onEnter={(node, appears) => {
                    play(pathname, node, appears)
                  }}
                  
                  onExit={(node, appears) => {
                    
                    exit(node, appears)}}
                    
                  timeout={{ enter: 750, exit: 150 }}
                >
                  <>
                  <ToTop/>
                  <Nav />
                  
                  <Switch id="switch" location={location}>
                      
                      <Route exact path="/" component={Home} />
                      <Route path="/description" component={Description} />
                      <Route path="/safety" component={Safety} />
                      <Route path="/education" component={Education} />
                      <Route path="/awards" component={Awards} />
                      <Route path="/hardware" component={Hardware} />
                      <Route path="/contribution" component={Contribution} />
                      <Route path="/engineering" component={Engineering} />
                      <Route path="/collaborations" component={Collaborations} />
                      <Route path="/model" component={Modeling} />
                      
                      <Route path="/proof-of-concept" component={ProofOfConcept} />
                      <Route path="/implementation" component={Implementation} />
                      <Route path="/attributions" component={Attribution} />
                      <Route path="/inclusivity" component={Inclusivity} />
                      
                      <Route path="/elona" component={Elona} />
                      <Route path="/mst" component={Mst} />
                      <Route path="/lfa" component={Lfa} />
                      <Route path="/lab_journal" component={LabJournal} />
                      <Route path="/lab_goals" component={LabGoals} />
                   
                      <Route path="/parts" component={Parts} />
                      <Route path="/entrepreneurship" component={Entrepreneurship} />

                      <Route path="/team" component={Team} />
                      {/* miising pages */}
                      <Route path="/human-practices" component={HumanPractices} />
                  </Switch>
                  <Footer />
                    </>
                </Transition>
              </TransitionGroup>
            );
          }}
        />
      </div>
    </BrowserRouter>
  );
};

export default App;
